import { render, staticRenderFns } from "./ProjectSurvey.vue?vue&type=template&id=5cfb28c0&"
import script from "./ProjectSurvey.vue?vue&type=script&lang=js&"
export * from "./ProjectSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports